export default function userFavouriteProducts() {
    if ($('.js-products-wrapper').length && window.userFavourites && window.userFavourites.productIDs.length > 0) {
        let arrFavourites = window.userFavourites.productIDs;
        $('.js-store-product').find('.js-to-favorite').removeClass('_in-favorite');

        $.each( arrFavourites, function( index, value ){
            $('.js-store-product[data-general-id="' + value + '"]').find('.js-to-favorite').addClass('_in-favorite');
        });
    } else {
        console.log('No')
    }
}
